import React, { FC } from 'react';
import { Link } from 'react-router-dom';

import { formatPackageNumber } from '../shared/packageUtils';
import styles from './PackageDetails.module.scss';

type Props = {
  packageUuid: string;
};

export const PackageDetailsBreadcrumbs: FC<Props> = ({ packageUuid }) => (
  <div className={styles.breadcrumbs}>
    <Link to="../../../../" relative="path" className={styles.breadcrumbLink}>
      Главная
    </Link>
    <span className={styles.breadcrumbSeparator}>/</span>
    <Link to="../../" relative="path" className={styles.breadcrumbLink}>
      Счет комфорт
    </Link>
    <span className={styles.breadcrumbSeparator}>/</span>
    <span className={styles.breadcrumbCurrent}>Пакет #{formatPackageNumber(packageUuid)}</span>
  </div>
);
